function isPlainObject(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}

function toNonEmptyStringArray(value) {
  if (Array.isArray(value)) {
    return value
      .map((item) =>
        typeof item === "string" ? item.trim() : String(item ?? "").trim(),
      )
      .filter(Boolean);
  }

  if (typeof value === "string") {
    return value
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);
  }

  return [];
}

export function csvFilterToArray(value) {
  return toNonEmptyStringArray(value);
}

export function normalizeCsvFilterValue(value) {
  const normalized = toNonEmptyStringArray(value);
  return normalized.length > 0 ? normalized.join(",") : undefined;
}

export function normalizeArrayFilterValue(value) {
  return toNonEmptyStringArray(value);
}

export function normalizeInboxFilters(filters) {
  if (!isPlainObject(filters)) return {};

  const normalized = {};

  for (const [key, value] of Object.entries(filters)) {
    // Família CSV: `channelId` fica aqui, e NÃO na família array, de propósito.
    // `normalizeCsvFilterValue("<uuid>")` devolve a string intacta, então todo
    // `channelId` de seleção única já persistido — e todo `savedViews[].filters` —
    // continua valendo sem migração de dados.
    if (key === "status" || key === "owner" || key === "channelId") {
      const normalizedValue = normalizeCsvFilterValue(value);
      if (normalizedValue !== undefined) normalized[key] = normalizedValue;
      continue;
    }

    if (key === "tagIds" || key === "priority") {
      const normalizedValue = normalizeArrayFilterValue(value);
      if (normalizedValue.length > 0) normalized[key] = normalizedValue;
      continue;
    }

    if (key === "locked" || key === "sessionActive") {
      if (typeof value === "boolean") {
        normalized[key] = String(value);
        continue;
      }

      if (typeof value === "string" && value.trim()) {
        normalized[key] = value.trim();
      }
      continue;
    }

    if (value === undefined || value === null || value === "") continue;
    normalized[key] = value;
  }

  return normalized;
}

export function normalizeInboxSavedViews(savedViews) {
  if (!Array.isArray(savedViews)) return [];

  return savedViews
    .map((view, index) => {
      if (!isPlainObject(view)) return null;

      return {
        ...view,
        filters: normalizeInboxFilters(view.filters || {}),
        position:
          typeof view.position === "number" && Number.isFinite(view.position)
            ? view.position
            : index,
      };
    })
    .filter(Boolean);
}

export function normalizeInboxPreferences(
  preferences,
  defaultPreferences = {},
) {
  const safePreferences = isPlainObject(preferences) ? preferences : {};
  const defaultSectionsCollapsed = isPlainObject(
    defaultPreferences.sectionsCollapsed,
  )
    ? defaultPreferences.sectionsCollapsed
    : {};

  const sectionsCollapsed = isPlainObject(safePreferences.sectionsCollapsed)
    ? {
        ...defaultSectionsCollapsed,
        ...Object.fromEntries(
          Object.entries(safePreferences.sectionsCollapsed).filter(
            ([, value]) => typeof value === "boolean",
          ),
        ),
      }
    : defaultSectionsCollapsed;

  return {
    ...defaultPreferences,
    ...safePreferences,
    activeFilters: normalizeInboxFilters(safePreferences.activeFilters),
    savedViews: normalizeInboxSavedViews(safePreferences.savedViews),
    defaultSort:
      typeof safePreferences.defaultSort === "string" &&
      safePreferences.defaultSort
        ? safePreferences.defaultSort
        : defaultPreferences.defaultSort,
    defaultSortDir:
      safePreferences.defaultSortDir === "asc" ||
      safePreferences.defaultSortDir === "desc"
        ? safePreferences.defaultSortDir
        : defaultPreferences.defaultSortDir,
    hiddenBuiltinViews: Array.isArray(safePreferences.hiddenBuiltinViews)
      ? safePreferences.hiddenBuiltinViews.filter(
          (value) => typeof value === "string" && value.trim(),
        )
      : defaultPreferences.hiddenBuiltinViews || [],
    sectionsCollapsed,
  };
}